import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { HexagonSmallTrigger } from "../../hexagon";
import { faMicrophone, faTimes } from "@fortawesome/pro-regular-svg-icons";

const StyledButton = styled.div`
    max-height: 4rem;
    max-width: 4rem;
    position: ${props => props.common.voxPosition === 'center' && 'absolute'};
	bottom: ${props => props.common.voxPosition === 'center' && '0'};
	right: ${props => props.common.voxPosition === 'center' && '0'};
    ${breakpoint('xs', 'sm')`
        margin-bottom: 0;
    `}

    button {
        background: none;
        outline: none;
        border: none;
        padding: 0;
        display: flex;
        justify-content: center;

        transform-origin: center;
        transition: 300ms transform ease-in-out;
        max-height: inherit;
        max-width: inherit;

        img {
            max-height: inherit;
            max-width: inherit;
        }
        div {
            padding: 0 !important;
        }
    }

    &.active {
        button {
            transform: rotate(0deg);
        }
    }

    &.inactive {
        button {
            transform: rotate(-180deg);
            filter: grayscale();
            div {
                svg{
                    transition: 0ms transform ease-in-out;
                    transform: rotate(180deg);
                    --trigger-color1: #9E9E9E !important;
                    --trigger-color2: #E9E9E9 !important;
                }
            }
        }
    }
`;

export default class PolygonButton extends Component {
    static propTypes = {
        isActive: PropTypes.bool.isRequired
    };

    render() {
        const { isActive: active, onToggle, className, common, title } = this.props;

        return (
            <StyledButton common={common} className={`${className} trigger-button ${active ? 'active' : 'inactive'}`}>
                <button onClick={onToggle}>
                    {active && <HexagonSmallTrigger common={common} icon={faMicrophone} title={title} />}
                    {!active && <HexagonSmallTrigger common={common} icon={faTimes} title={title} />}
                </button>
            </StyledButton>
        )
    }
}
